import { useHead } from '@unhead/react';
import { useTranslation } from 'translations/hooks';

import { MobileSingleCardPageWithFilterLayout } from 'business/layout/single-card-page-with-filter-card/mobile';
import { TableParamsProvider } from 'business/providers/table-params';
import { RingComplianceFilters } from 'business/quality-control/pages/ring-compliance-report/components/filters';
import { RingComplianceTable } from 'business/quality-control/pages/ring-compliance-report/components/ring-compliance-table';
import { useRingComplianceReportFilterParams } from 'business/quality-control/pages/ring-compliance-report/hooks/use-filter-params';
import { RingComplianceReportFiltersProvider } from 'business/quality-control/pages/ring-compliance-report/providers/filters';
import { RingComplianceReportFilterData } from 'business/quality-control/pages/ring-compliance-report/types';
import { useFilterData } from 'technical/filter-data';

export function MobileRingComplianceReportPage() {
  const { t } = useTranslation();

  const { filterData, setFilterData } =
    useFilterData<RingComplianceReportFilterData>();

  const {
    initialFilters,
    initialCurrentPage,
    initialPageSize,
    initialSortField,
    initialSortOrder,
  } = useRingComplianceReportFilterParams();

  useHead({
    title: t('user.menu.sections.qualityControl.ringComplianceReport.title'),
  });

  return (
    <TableParamsProvider
      defaultPageSize={initialPageSize}
      defaultCurrentPage={initialCurrentPage}
      defaultSortField={initialSortField}
      defaultSortOrder={initialSortOrder}
    >
      <RingComplianceReportFiltersProvider initialFilters={initialFilters}>
        <MobileSingleCardPageWithFilterLayout
          title={t(
            'user.menu.sections.qualityControl.ringComplianceReport.title',
          )}
          filters={<RingComplianceFilters filterData={filterData} />}
        >
          <RingComplianceTable setFilterData={setFilterData} mobile />
        </MobileSingleCardPageWithFilterLayout>
      </RingComplianceReportFiltersProvider>
    </TableParamsProvider>
  );
}
